
import {throwError as observableThrowError, Observable} from 'rxjs';
import { catchError } from "rxjs/operators";
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AppSettings} from '../app-settings';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

@Injectable()
export class HttpClientService {

  constructor(private http: HttpClient, private router: Router) {}

  createAuthorizationHeader(headers: HttpHeaders) {
  if (localStorage.getItem('id_token'))
  {
    headers.append('X-Authorization', 'Bearer ' +
      localStorage.getItem('id_token'));
      }
      headers.append('Content-Type', 'application/json');
      headers.append('Cache-Control', 'no-cache');
  }
changeResponse(jsonResponse:Response){
  if (jsonResponse["_body"]=="" || jsonResponse["_body"]==null)
    jsonResponse["_body"]={"response":"not found"};
  return jsonResponse.json();
}

checkLogin(e)
{
  if (e.status === 401 || e.status === 410) {
      localStorage.setItem("blitzkriegRedirectUrl", window.location.href);
      document.cookie = "userLoginCookie=;expires=Thu, 18 Dec 2011 12:00:00 UTC;domain=.e-gmat.com;path=/";
      window.location.href = AppSettings.publicSiteURL;
      return observableThrowError('Unauthorized');
  }
  if (e.status === 420) {
      this.router.navigate(['/forbidden']);
      return observableThrowError('Unauthorized');
  }
  if(e.status === 400)
  {
    const error:HttpErrorResponse = e;
    return observableThrowError(error.error);
  }
  if(e.status === 500)
  {
    const error:HttpErrorResponse = e;
    return observableThrowError(error.error);
  }
  if(e.status === 429)
  {
     this.router.navigate(['/request-overload-page']);
  }
}

  get(url:any, headers:HttpHeaders) : Observable<any> {

    this.createAuthorizationHeader(headers);

    return this.http.get(url,  {
        headers: headers, withCredentials:true
      }) //my back-end return a JSON. Unwrap it
      .pipe(catchError( e => {
          return this.checkLogin(e);
          // do any other checking for statuses here
        }));
  }
  getSync(url:any, headers:HttpHeaders) : Promise<any> {

    this.createAuthorizationHeader(headers);

    return this.http.get(url,  {
        headers: headers, withCredentials:true
      }).toPromise(); //my back-end return a JSON. Unwrap it

  }

  post(url:any, data:any, headers:HttpHeaders) : Observable<any>{

   this.createAuthorizationHeader(headers);

    return this.http.post(url, data, {
        headers: headers, withCredentials:true
      }) //my back-end return a JSON. Unwrap it

      .pipe(catchError( e => {
        return this.checkLogin(e);
        // do any other checking for statuses here
      }));
  }

  postEvent(url:any, data:any, headers:HttpHeaders) : Observable<any>{

    return this.http.post(url, data, {
        headers: headers
      }) //my back-end return a JSON. Unwrap it
      .pipe(catchError( e => {
        return this.checkLogin(e);
        // do any other checking for statuses here
      }));
  }

  put(url:any, data:any, headers:HttpHeaders) : Observable<any>{

   this.createAuthorizationHeader(headers);

    return this.http.put(url, data, {
        headers: headers, withCredentials:true
      }) //my back-end return a JSON. Unwrap it
      .pipe(catchError( e => {
        return this.checkLogin(e);
        // do any other checking for statuses here
      }));
  }
  delete(url:any, headers:HttpHeaders) : Observable<any> {

    this.createAuthorizationHeader(headers);

    return this.http.delete(url,  {
        headers: headers, withCredentials:true
      }) //my back-end return a JSON. Unwrap it
      .pipe(catchError( e => {
        return this.checkLogin(e);
        // do any other checking for statuses here
      }));
  }

  /**
   * @description checks string is valid url
   * @param urlString
   * @returns
   */

  isValidUrl( urlString:string):boolean{
    const regex = new RegExp(/^((https|http):\/\/)/);
   return regex.test(urlString);
}
}
